import React from 'react';
import "./AnnotationDivider.css";

const AnnotationDivider = ({ timeline, formatSectionHeaderStr, formatTime }) => {
  return (
    <div className="annotation-section-divider">
      <span className="annotation-section-divider-label">
        {formatSectionHeaderStr(timeline.timeline)} [{formatTime(timeline.frames[0][
          "in-label"] ? timeline.frames[0][
        "in-label"] : timeline.frames[0].in)}]
      </span>
      <span className="annotation-section-divider-line"></span>
    </div>
  )
}

export default AnnotationDivider;